import React from 'react';
import classNameBind from 'classnames/bind';
import { useMediaQuery } from 'react-responsive';

import { useTranslation } from '../../../Translator';
import Button from '../../../Button';
import styles from './Buttons.module.css';

const bindClasses = classNameBind.bind(styles);

const Buttons = ({
  debugButton,
  publishButton,
}) => {
  const { t } = useTranslation('components');
  const isMobile = useMediaQuery({ query: '(max-width: 960px)' });

  return (
    <div
      className={bindClasses('wrapper')}
      data-ppuc-id="ProductBar.Buttons"
    >
      {debugButton && (
        <Button
          text={isMobile ? undefined : t('debugLabel')}
          disabled={debugButton.disabled}
          onClick={() => { debugButton.onClick(); }}
          icon={isMobile ? 'debug' : undefined}
          dataId="ProductBar.Buttons.debug"
        />
      )}
      {publishButton && (
        <Button
          appearance="primary"
          text={isMobile ? undefined : t('publishLabel')}
          onClick={() => { publishButton.onClick(); }}
          disabled={publishButton.disabled}
          icon={isMobile ? 'upload' : undefined}
          dataId="ProductBar.Buttons.publish"
        />
      )}
    </div>
  );
};

Buttons.defaultProps = {
  debugButton: {
    disabled: false,
    onClick: () => {},
  },
  publishButton: {
    disabled: false,
    onClick: () => {},
  },
};

export { Buttons };
